module.exports = __webpack_public_path__ + "img/5.17066bed.jpg";